module.exports = __webpack_public_path__ + "img/1505640339.299e2a75.jpg";